globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { CardWrapper, CardVenueDetails, CardSubscriptionDetails } from './worker-base-card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function WorkerVenueCard(_ref) {
  var venueLogo = _ref.venueLogo,
      venueName = _ref.venueName,
      firstSubDate = _ref.firstSubDate,
      city = _ref.city,
      href = _ref.href,
      newTab = _ref.newTab,
      wrapperStyle = _ref.wrapperStyle;
  var variant = 'venue';
  return /*#__PURE__*/_jsxs(CardWrapper, {
    variant: variant,
    href: href,
    newTab: newTab,
    wrapperStyle: wrapperStyle,
    children: [/*#__PURE__*/_jsx(CardVenueDetails, {
      variant: variant,
      logoSrc: venueLogo,
      city: city,
      venueName: venueName
    }), /*#__PURE__*/_jsx(CardSubscriptionDetails, {
      firstSubDate: firstSubDate
    })]
  });
}